<template>
    <div>
        <b-collapse v-for="question in this.questions" :key="question.id" class="colap-barra mb-4"
            animation="slide" :aria-id="'collapse' + question.id" :open="openQuestionId == question.id" :id="`q${question.id}`"
            @open="onQuestionOpen(question.id)">
            <template slot="trigger" slot-scope="props">
                <button :class="props.open ? 'colap-button-down' : 'colap-button'" role="button"
                    :aria-controls="'collapse' + question.id" @click="navigateToQuestion(question.id)">
                    <h2 class="colap-header">
                        <span class="has-text-black">{{ question.question }}</span>
                    </h2>
                    <span class="card-header-icon">
                        <!-- <b-icon :icon="props.open ? 'menu-down' : 'menu-up'" aria-hidden="1"></b-icon> -->
                        <!-- <b-icon :icon="props.open ? 'chevron-down' : 'chevron-up'" aria-hidden="true"></b-icon> -->
                        <i :class="props.open ? 'fas fa-caret-up' : 'fas fa-caret-down'"></i>
                    </span>
                </button>
            </template>

            <div class="colap-cont">
                <div v-html="question.answer" class="mb-4 answerView" :ref="'answerView_' + question.id"></div>
                <p class="update-date">Actualizado el {{ dateExist(question) }}</p>
            </div>
        </b-collapse>
    </div>
</template>

<script>
export default {
    name: "PreguntasFrecuentesContent",
    props: ['questions', 'topic_id'],
    data() {
        return {
            openQuestionId: null
        }
    },
    methods: {
        formatDate: function (date) {
            return moment(date).format("D") + ' de ' + moment(date).format("MMMM") + ' de ' + moment(date).format("YYYY");
        },
        dateExist: function (question) {
            if (question.updated_at) {
                return this.formatDate(question.updated_at);
            } else {
                return this.formatDate(question.created_at);
            }
        },
        isQuestionOpen(questionId) {
            const hash = window.location.hash;
            return hash === `#q${questionId}`;
        },
        getQuestionUrl(questionId) {
            const url = new URL(window.location.href);
            url.hash = `q${questionId}`;
            return url.toString();
        },
        onQuestionOpen(questionId) {
            this.openQuestionId = questionId;
        },
        navigateToQuestion(questionId) {
            const url = new URL(window.location.href);
            url.hash = `q${questionId}`;
            window.location.href = url.toString();
        },

        // addLinkClass() {
        //     this.$nextTick(() => {
        //         this.questions.forEach(q => {
        //         const refName = `answerView_${q.id}`;
        //         const el = this.$refs[refName];
        //         if (el && el.length === undefined) {
        //             const links = el.querySelectorAll('a');
        //             links.forEach(link => {
        //             link.classList.add('link');
        //             });
        //         }
        //         });
        //     });
        // }
    },
    updated() {
        this.$nextTick(() => {
            setTimeout(() => {
            document.querySelectorAll('.answerView a').forEach(link => {
                link.classList.add('link');
            });
            }, 500); // o un valor como 100ms si aún no lo toma
        });
    },

    mounted() {
        if (window.location.hash) {
            const questionId = window.location.hash.replace('#q', '');
            this.openQuestionId = questionId;
            const element = document.querySelector(window.location.hash);
            if (element) {
                setTimeout(() => {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    //element.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        }
        //this.addLinkClass();
    }
}
</script>
<style scoped>
::v-deep(.colap-cont a){
  text-decoration: underline !important;
  cursor: pointer;
}

::v-deep(.colap-button:focus),
::v-deep(.colap-button-down:focus) {
  background-color: #ffffff !important;
  border: 3px solid #000000 !important;
  outline: 3px solid #fcbc5c !important;
  outline-offset: 0px;
}

.update-date {
  text-align: right;
  font-size: 12px;
}
</style>
